<template>
  <v-dialog
    v-model="linkEditor"
    persistent
    :fullscreen="mobile"
    :max-width="mobile ? '120%' : '80%'"
    :retain-focus="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="mode == 'create'"
        v-bind="attrs"
        v-on="on"
        right
        style="float:right"
        color="secondary"
        v-on:click="prepareToCreateNewLink()"
        ><v-icon small left>fas fa-plus</v-icon>Novo Redirecionamento</v-btn
      >
      <div
        v-if="mode == 'first'"
        v-on:click="prepareToCreateNewLink(true)"
        style="cursor:pointer"
      >
        <v-alert
          border="bottom"
          colored-border
          type="info"
          color="secondary"
          class="text-center"
          elevation="2"
        >
          Primeira vez? Clique aqui para criar seu primeiro link.
        </v-alert>
      </div>

      <v-btn
        v-if="mode == 'edit'"
        v-bind="attrs"
        v-on="on"
        x-small
        icon
        v-on:click="loadPhoneDetails()"
        style="margin-left:15px;margin-right:15px;"
        color="accent"
      >
        <v-icon>fas fa-pencil-alt</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-list-item two-line>
        <v-list-item-avatar tile size="50">
          <v-icon color="secondary" size="30px">fas fa-link</v-icon>
        </v-list-item-avatar>
        <v-list-item-content style="user-select:none">
          <v-list-item-title class="headline mb-1" style="font-weight:500">
            <span v-if="mode == 'create'"
              >Novo <br v-if="mobile" />
              Redirecionamento</span
            >
            <span v-if="mode == 'first'"
              >Primeiro <br v-if="mobile" />
              Redirecionamento</span
            >
            <span v-if="mode == 'edit'"
              >Alterar <br v-if="mobile" />
              Redirecionamento</span
            >
            <span
              class="closeBtn"
              v-bind:style="{ top: mobile ? '-30px' : '-5px' }"
              @click="linkEditor = false"
              ><v-icon color="error">fas fa-times</v-icon></span
            >
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-card-text>
        <v-form>
          <v-container fluid class="my-0 py-0">
            <v-row class="my-0 py-0">
              <v-col cols="12" v-if="mode == 'first'">
                Deixe-nos te ajudar a criar seu primeiro link na plataforma
                WhatsRedirect.
              </v-col>
              <v-col cols="12" md="4" class="my-0 py-0">
                <v-text-field
                  :disabled="disableForm"
                  :counter="15"
                  v-model="linkData.name"
                  :rules="rules.required"
                  label="Nome do Link"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8" class="my-0 py-0">
                <v-text-field
                  :disabled="disableForm"
                  v-model="linkData.msg"
                  label="Mensagem padrão (Opcional)"
                >
                  <!-- <template v-slot:append-outer>
                    <v-btn small icon color="primary">
                      <v-icon small>fas fa-bold</v-icon>
                    </v-btn>
                    <v-btn small icon color="primary">
                      <v-icon small>fas fa-italic</v-icon>
                    </v-btn>
                    <v-btn small icon color="primary">
                      <v-icon small>fas fa-strikethrough</v-icon>
                    </v-btn>
                  </template> -->
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-expansion-panels
                  accordion
                  focusable
                  v-model="insertNumber"
                  class="my-0 py-0"
                >
                  <v-expansion-panel class="my-0 py-0">
                    <v-expansion-panel-header
                      disable-icon-rotate
                      class="my-0 py-0"
                    >
                      <v-list flat class="my-0 py-0">
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon color="secondary">fas fa-mobile-alt</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              >Inserir Número</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <template v-slot:actions>
                        <v-icon color="secondary">fas fa-plus-circle</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row class="ma-0 pa-0">
                        <v-col cols="12" md="6" class="my-0 py-0 pl-0">
                          <v-text-field
                            :disabled="disableForm"
                            label="Nome do Telefone"
                            :rules="rules.required"
                            v-model="newPhone.name"
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col cols="8" md="4" class="my-0 py-0  pl-0">
                          <v-text-field
                            hide-details
                            :disabled="disableForm"
                            label="Número"
                            v-model="newPhone.number"
                            type="tel"
                            v-mask="[
                              '+55 (##) ####-####',
                              '+55 (##) #####-####'
                            ]"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="4"
                          md="2"
                          class="my-0 pa-0"
                          align-self="end"
                        >
                          <v-btn
                            small
                            color="secondary"
                            v-on:click="addPhone()"
                            style="float:right"
                            >Inserir</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
              <v-col cols="12" v-if="phoneNumbers.length > 0">
                <div v-if="mode == 'first'" style="margin-bottom:10px">
                  <span>
                    Selecione pelo menos um número:
                  </span>
                </div>
                <v-data-table
                  :loading="loadingPhones"
                  loading-text="Carregando itens, aguarde..."
                  :headers="phonesHeader"
                  :items="phoneNumbers"
                  :value="linkData.phones"
                  :items-per-page="15"
                  :hide-default-footer="phoneNumbers.length <= 15"
                  dense
                  show-select
                  class="elevation-1"
                  mobile-breakpoint="10px"
                >
                  <template v-slot:header.data-table-select="{ on, props }">
                    <v-simple-checkbox
                      color="primary"
                      v-bind="props"
                      v-on:input="selectUnselectAllPhones()"
                      v-on="on"
                    ></v-simple-checkbox>
                  </template>
                  <template
                    v-slot:item.data-table-select="{ item, isSelected, select }"
                  >
                    <v-simple-checkbox
                      color="secondary"
                      v-model="item.selected"
                      @input="select($event)"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.times="{ item }">
                    <v-btn
                      x-small
                      icon
                      color="error"
                      v-on:click="changeFrequency(false, item.id)"
                      :disabled="!item.selected || item.times < 2"
                    >
                      <v-icon x-small>fas fa-minus</v-icon></v-btn
                    >
                    <span style="margin:0 5px; user-select:none">{{
                      item.times
                    }}</span>
                    <v-btn
                      x-small
                      icon
                      color="success"
                      v-on:click="changeFrequency(true, item.id)"
                      :disabled="!item.selected"
                    >
                      <v-icon x-small>fas fa-plus</v-icon></v-btn
                    >
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          v-if="mode == 'create'"
          text
          v-on:click="createLink()"
          >Inserir Link</v-btn
        >
        <v-btn
          color="secondary"
          v-if="mode == 'first'"
          text
          v-on:click="createLink()"
          >Criar Link</v-btn
        >
        <v-btn
          color="secondary"
          v-if="mode == 'edit'"
          text
          v-on:click="updateLink()"
          >Alterar Link</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog v-model="successModal.show" width="500">
      <v-card>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-icon x-large color="secondary">far fa-check-circle</v-icon>
              </v-col>
              <v-col cols="12" class="text-center">
                <span class="SuccessTitle">Concluído</span>
              </v-col>
              <v-col cols="12" class="text-center">
                <span class="SuccessText"
                  >Seu novo Link já pode ser utilizado:</span
                >
              </v-col>
              <v-col cols="12" class="text-center">
                <v-text-field
                  readonly
                  :value="successModal.link"
                  class="centered-input"
                  v-on:click="copyToClipboard()"
                  :messages="successModal.showMessage"
                  id="linkInput"
                >
                  <template v-slot:message>
                    <div class="text-center" style="color: #60ba8e;">
                      {{ successModal.message }}
                    </div>
                  </template>
                  <template v-slot:append>
                    <v-btn icon color="info" v-on:click="copyToClipboard()"
                      ><v-icon>fas fa-copy</v-icon></v-btn
                    >
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeAll()">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import Axios from "axios";
import Swal from "sweetalert2";
import { mask } from "vue-the-mask";

export default Vue.extend({
  props: ["link", "mode", "mobile"],
  directives: { mask },
  data: () => ({
    disableForm: false,
    linkData: {
      name: "",
      msg: "",
      phone: []
    },
    rules: {
      required: [
        (v) => !!v || "Nome Obrigatório",
        (v) => (v && v.length <= 15) || "Excedido Limite de tamanho"
      ]
    },
    newPhone: {
      name: "",
      number: "",
      schedule: {
        sun: [["00:00", "23:59"]],
        mon: [["00:00", "23:59"]],
        tue: [["00:00", "23:59"]],
        wed: [["00:00", "23:59"]],
        thu: [["00:00", "23:59"]],
        fri: [["00:00", "23:59"]],
        sat: [["00:00", "23:59"]]
      }
    },
    linkEditor: false,
    loadingPhones: true,
    insertNumber: -1,
    phonesHeader: [],
    phoneNumbers: [],
    successModal: {
      show: false,
      link: "",
      showMessage: "",
      message: "Link copiado para área de transferência!"
    }
  }),
  computed: {},
  methods: {
    mtel: function(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d{2})(\d{4,5})(\d{4})/g, "+$1 ($2) $3-$4");
      return v;
    },
    loadPhones: function(reload = false) {
      this.loadingPhones = true;
      Axios.get("/api/v1/phones/list", {
        params: { simple: true }
      }).then((response) => {
        const phones = response.data.phone_list;
        phones.forEach((phone) => {
          let isNew = true;
          this.phoneNumbers.forEach((old) => {
            if (old.id == phone.id) {
              isNew = false;
            }
          });
          if (isNew) {
            this.phoneNumbers.push({
              selected: reload,
              id: phone.id,
              name: phone.name,
              phone: this.mtel(phone.number),
              times: 1
            });
          }
        });
        this.insertNumber = undefined;
        if (this.phoneNumbers.length == 0) {
          this.insertNumber = 0;
        }
        this.loadingPhones = false;
      });
    },
    selectUnselectAllPhones: function() {
      let totalPhoneSelected = 0;
      let numOfPhones = 0;
      this.phoneNumbers.forEach((element) => {
        numOfPhones++;
        totalPhoneSelected += element.selected ? 1 : 0;
      });
      if (totalPhoneSelected > 0 && totalPhoneSelected != numOfPhones) {
        this.phoneNumbers.forEach((element) => {
          element.selected = true;
        });
      } else if (numOfPhones > 0 && totalPhoneSelected == numOfPhones) {
        this.phoneNumbers.forEach((element) => {
          element.selected = false;
        });
      } else {
        this.phoneNumbers.forEach((element) => {
          element.selected = true;
        });
      }
    },
    changeFrequency: function(up, id) {
      this.phoneNumbers.forEach((element) => {
        if (element.id == id) {
          element.times += up ? 1 : -1;
          return true;
        }
      });
    },
    prepareToCreateNewLink: function(first = false) {
      this.loadPhones();
      this.linkData.name = "";
      this.linkData.msg = "";
      this.linkData.phone = [];
      this.phoneNumbers.forEach((element) => {
        element.selected = false;
      });
      this.linkEditor = first;
    },
    loadPhoneDetails: async function() {
      await this.loadPhones();
      Axios.get("/api/v1/links/load", {
        params: {
          id: this.link
        }
      }).then((response) => {
        const data = response.data;
        if (data.status == "success") {
          this.linkData.name = data.data.name;
          this.linkData.msg = data.data.msg;
          this.linkData.phone = data.data.phone;
          this.linkData.phone.forEach((phone) => {
            this.phoneNumbers.forEach((element) => {
              if (phone[0] == element.id) {
                element.selected = true;
                element.times = phone[1];
              }
            });
          });
        }
      });
    },
    createLink: function() {
      this.successModal.showMessage = "";
      this.disableForm = true;
      let dataReturn;
      this.linkData.phone = [];
      this.phoneNumbers.forEach((element) => {
        if (element.selected) {
          this.linkData.phone.push([element.id, element.times]);
        }
      });

      // eslint-disable-next-line no-unreachable
      Swal.fire({
        title: "Confirma a insersão deste novo Link?",
        showCancelButton: true,
        confirmButtonColor: "#60ba8e",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#B80C09",
        reverseButtons: true,
        icon: "question",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: async () => {
          this.linkData.name = this.titleCase(this.linkData.name);
          await Axios.post("/api/v1/links/add", { data: this.linkData }).then(
            (response) => {
              dataReturn = response.data;
            }
          );
        }
      }).then((result) => {
        if (result.value) {
          if (dataReturn.status == "success") {
            this.successModal.link = dataReturn.link;
            this.successModal.show = true;
          } else {
            Swal.fire({
              title: "Erro!",
              text: dataReturn.msg,
              icon: "error",
              confirmButtonText: "OK!"
            });
          }
        }
        this.disableForm = false;
      });
    },
    copyToClipboard: function() {
      const el = document.getElementById("linkInput");
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.successModal.showMessage = "1";
    },
    closeAll: function() {
      this.$emit("reload-data");
      this.successModal.show = false;
      this.linkEditor = false;
    },
    updateLink: function() {
      this.disableForm = true;
      let dataReturn;
      this.linkData.phone = [];
      this.phoneNumbers.forEach((element) => {
        if (element.selected) {
          this.linkData.phone.push([element.id, element.times]);
        }
      });
      Swal.fire({
        title: "Confirma a alteração deste Link?",
        showCancelButton: true,
        confirmButtonColor: "#60ba8e",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#B80C09",
        focusConfirm: true,
        reverseButtons: true,
        icon: "question",
        showLoaderOnConfirm: true,
        onOpen: () => Swal.getFocusableElements(),
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: async () => {
          this.linkData.name = this.titleCase(this.linkData.name);
          await Axios.put("/api/v1/links/update", {
            id: this.link,
            data: this.linkData
          }).then((response) => {
            dataReturn = response.data;
          });
        }
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            title: dataReturn.status == "success" ? "Concluído!" : "Erro!",
            text: dataReturn.msg,
            icon: dataReturn.status == "success" ? "success" : "error",
            confirmButtonText: "OK!"
          }).then(() => {
            if (dataReturn.status == "success") {
              this.$emit("reload-data");
              this.linkEditor = false;
            }
          });
        }
        this.disableForm = false;
      });
    },
    titleCase: function(str) {
      const splitStr = str.toLowerCase().split(" ");
      for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },
    addPhone: function() {
      this.newPhone.name = this.titleCase(this.newPhone.name);
      Axios.post("/api/v1/phones/add", {
        newdata: this.newPhone
      }).then((response) => {
        if (response.data.status != "fail") {
          this.newPhone.name = "";
          this.newPhone.number = "";
        }
        this.loadPhones(true);
      });
    }
  },
  mounted() {
    this.phonesHeader = [];
    this.phoneNumbers = [];
    this.showCopyArea = false;
    if (this.mobile) {
      this.phonesHeader.push({ text: "Nome", value: "name" });
      this.phonesHeader.push({
        text: "Frequência",
        value: "times",
        sortable: false,
        align: "center"
      });
    } else {
      this.phonesHeader.push({ text: "Nome", value: "name" });
      this.phonesHeader.push({
        text: "Número",
        value: "phone",
        sortable: false,
        align: "center"
      });
      this.phonesHeader.push({
        text: "Frequência",
        value: "times",
        sortable: false,
        align: "center"
      });
    }
    if (this.mode == "first") {
      this.prepareToCreateNewLink(true);
    }
  }
});
</script>
<style>
.closeBtn {
  float: right;
  cursor: pointer;
  position: relative;
}
.SuccessTitle {
  color: #60ba8e;
  font-size: 30px;
  text-transform: uppercase;
  user-select: none;
}
.SuccessText {
  font-size: 20px;
  user-select: none;
}
.centered-input input {
  text-align: center !important;
}
</style>
